
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsBrandGrid extends Serenity.EntityGrid<CsBrandRow, any> {
        protected getColumnsKey() { return CsBrandColumns.columnsKey; }
        // protected getIsActiveProperty() { return CsBrandRow.isActiveProperty; }
        protected getDialogType() { return CsBrandDialog; }
        protected getIdProperty() { return CsBrandRow.idProperty; }
        protected getInsertPermission() { return CsBrandRow.insertPermission; }
        protected getLocalTextPrefix() { return CsBrandRow.localTextPrefix; }
        protected getService() { return CsBrandService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        // protected getColumns() {
        //     var columns = super.getColumns();

            
    
        //     columns.unshift({
        //         id: 'Delete',
        //         field: null,
        //         name: '',
        //         cssClass: 'align-center',
        //         format: ctx => {
        //             return '<a class="inline-action" data-action="delete-row" title="Delete">'+
        //             '<i class="fa fa-trash-o text-red"></i></a>';
        //         },
        //         width: 36,
        //         minWidth: 36,
        //         maxWidth: 36
        //     });
    
        //     columns.splice(1, 0, {
        //         id: 'View Detail',
        //         field: null,
        //         name: '',
        //         cssClass: 'align-center',
        //         format: ctx => {
        //             return '<a class="inline-action" data-action="view-details" title="View Details">'+
        //             '<i class="fa fa-search text-blue"></i></a>';
        //         },
        //         width: 36,
        //         minWidth: 36,
        //         maxWidth: 36
        //     });
    
        //     return columns;
        // }
    
        // // protected onClick(e: Event, row: number, cell: number) {
        // //     super.onClick(e, row, cell);

        // protected onClick(e: JQueryEventObject, row: number, cell: number) {
        //     super.onClick(e, row, cell);
            
        //     // var item = this.itemAt(row);
        //     // var target = $(e.target);

        //     // if (Fluent.isDefaultPrevented(e)) return;
    
        //     var item = this.itemAt(row);
        //     let action = (e.target as HTMLElement)?.closest(".inline-action")?.getAttribute("data-action");
            
        //     if (action) {
        //         e.preventDefault();
        //         if (action == "view-details") {
        //             this.editItem(item.BrandCode);
        //         } else if (action == "delete-row") {

        //             var Brandid = Q.tryFirst(CsSkuRow.getLookup().items,x => x.BrandCode == item.BrandCode);
        //     if(Brandid != null){
        //         // this.deleteButton.toggleClass('disabled', true);
        //         Q.warning("ข้อมูลนี้ไม่สามารถลบได้เนื่องจาก มีการใช้ข้อมูลอยู่")                
        //     }else{
        //             Q.confirm('Delete record?', () => {
        //                 CsBrandService.Delete({
        //                     EntityId: item.BrandCode,
        //                 }, response => {
        //                     this.refresh();
        //                 });
        //             });
        //             }
        //         }
        //     }
        // }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}